import { Link } from 'react-router';
import template from 'lodash.template';

import marketplace from 'cfg/marketplace.json';
import { parseHtmlToReact } from 'helpers/HtmlHelpers';
import css from 'styles/components/checkout/caap/spc/termsConditionsAndNotes.scss';

const { shortName, checkout: { footerText, helpUrl: { salesTax, conditionsOfUse, privacyNotice, privacyNoticeText, conditionsOfUseText = 'conditions of use' } } } = marketplace;
const notesTemplate = template(footerText);

export const NotesSection = () => (
  <footer className={css.checkoutFooter}>
    <div>{parseHtmlToReact(notesTemplate({ salesTax: salesTax }))}</div>
  </footer>
);

export const TermsAndConditionsSection = () => (
  <div className={css.termsAndConditions}>
        By placing your order, you agree to {shortName}.com&#8217;s <Link to={privacyNotice}>{privacyNoticeText}</Link> and <Link to={conditionsOfUse}>{conditionsOfUseText}</Link>.
  </div>
);
